import api from './api';

// Public API anahtarları — iç yönetim uçları (backend ApiKeyController,
// [Route("v1/api-keys")]; sınıf düzeyinde PA.Read, mutasyonlar PA.Write).
// Kullanıcı JWT'si (web'de çerez) ile çağrılır; API anahtarının kendisi bu uçlara
// GİREMEZ (tasarım belgesi §4.5, Kilit 2).
//
// Yanıt tipleri (camelCase):
//   ApiKeyResponse        { id, name, maskedKey, permissions[], expiresAt, lastUsedAt, revokedAt, createDate }
//   ApiKeyCreatedResponse ApiKeyResponse + plainKey — TAM anahtar YALNIZ oluşturma/yenileme
//                         yanıtında bir kez gelir; liste ucu onu ASLA döndürmez.

// İptal edilenler dahil, oluşturma tarihine göre azalan.
export const getApiKeys = () => api.get('/v1/api-keys');

// Sınır modeli: { maxApiKeys, primaryCount, transitionCount }. Sunucunun oluşturma/yenileme
// kapısının KULLANDIĞI sayımın aynısı — "Yenile" eylemi buna göre devre dışı kalır.
export const getApiKeyLimits = () => api.get('/v1/api-keys/limits');

// Gövde: { name, permissions: ['EM.Read', ...] } — yalnız ".Read" ile bitenler (K5).
export const createApiKey = (payload) => api.post('/v1/api-keys', payload);

// Yeni anahtar üretir; eski anahtar 30 gün daha çalışır (eskiye expiresAt verilir).
export const rotateApiKey = (id) => api.post(`/v1/api-keys/${id}/rotate`);

// Kalıcı iptal — geri alınamaz.
export const revokeApiKey = (id) => api.delete(`/v1/api-keys/${id}`);
